import { ImageIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ImageUpload = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ImageIcon size={Sizes[size]} {...rest} color={fill} />;
};

ImageUpload.displayName = 'ImageUpload';
